import axiosClient from "utils/api";
const URI = "/drive";

export const getHomeFilesFolder = async (payload) => {
  const URL = `${URI}/home`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
      params: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during get Home Files Folder :", error);
    throw error;
  }
};

export const getRecentFilesFolder = async (payload) => {
  const URL = `${URI}/recent`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
      params: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during get recent Files Folder :", error);
    throw error;
  }
};

export const getSharedFilesFolder = async (payload) => {
  const URL = `${URI}/shared`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
      params: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during get shared Files Folder :", error);
    throw error;
  }
};

export const searchFilesFolder = async (payload) => {
  const URL = `${URI}/search`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
      params: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during search Files Folder :", error);
    throw error;
  }
};

export const restoreFilesFolder = async (payload) => {
  const URL = `${URI}/restore`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "post",
      data: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during restore Files Folder :", error);
    throw error;
  }
};

export const addFeedback = async (payload) => {
  const URL = `general/feedback`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "post",
      data: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during feedback:", error);
    throw error;
  }
};

export const getSetting = async () => {
  const URL = `general/getSetting`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during get setting:", error);
    throw error;
  }
};

export const trashFilesFolder = async (payload) => {
  const URL = `${URI}/trash`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "post",
      data: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during trash Files Folder :", error);
    throw error;
  }
};

export const deletePermanentlyFilesFolder = async (payload) => {
  const URL = `${URI}/delete`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "delete",
      data: payload,
    });
    return response.data;
  } catch (error) {
    console.error(
      "Error occurred during delete permanently Files Folder :",
      error,
    );
    throw error;
  }
};

export const getHelpAndFeedback = async (payload) => {
  const URL = `general/helpAndFeedback`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
      params: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during help and feedback:", error);
    throw error;
  }
};

export const suggestionsForMail = async (payload) => {
  const URL = `mail/users`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "post",
      data: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during suggestions for mail:", error);
    throw error;
  }
};

export const downloadFileFolderZIP = async (payload) => {
  const URL = `${URI}/download/fileAndFolders`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "post",
      data: payload,
      responseType: "arraybuffer",
    });
    return response;
  } catch (error) {
    console.error("Error occurred during download File Folder ZIP:", error);
    throw error;
  }
};

export const starUnstarFileFolder = async (payload) => {
  const URL = `${URI}/starred`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "post",
      data: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during star/Unstar File/Folder:", error);
    throw error;
  }
};

export const getStarredFileFolderList = async (payload) => {
  const URL = `${URI}/starred`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
      params: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during get star File/Folder:", error);
    throw error;
  }
};

export const lockUnlockFileFolder = async (payload) => {
  const URL = `${URI}/secure`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "post",
      data: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during secure File/Folder:", error);
    throw error;
  }
};

export const verifySecureFileFolder = async (payload) => {
  const URL = `${URI}/verify`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "post",
      data: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during verify Secure File/Folder:", error);
    throw error;
  }
};

export const getLockedFileFolderList = async (payload) => {
  const URL = `${URI}/secure`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
      params: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during secure File/Folder list:", error);
    throw error;
  }
};

export const getOpenFile = async (payload) => {
  const { id, ...rest } = payload;
  const URL = `${URI}/open/${id}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
      data: rest,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during open file :", error);
    throw error;
  }
};

export const getOpenFilePublic = async (payload) => {
  const { token, ...rest } = payload;
  const URL = `${URI}/sharedLink/public/${token}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
      data: rest,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during open file :", error);
    throw error;
  }
};

export const getOpenPublicFolder = async (payload) => {
  const URL = `${URI}/public/folders`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
      params: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during open file :", error);
    throw error;
  }
};

export const getLanguage = async () => {
  const URL = `general/language`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during get language:", error);
    throw error;
  }
};

export const peopleSuggestion = async () => {
  const URL = `${URI}/share/suggestions`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during get language:", error);
    throw error;
  }
};

export const requestShareFileAccess = async (payload) => {
  const URL = `${URI}/accessRequest`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "post",
      data: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during request share file access:", error);
    throw error;
  }
};

export const getAccessRequest = async (payload) => {
  const URL = `${URI}/accessRequest`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
      params: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during request share file access:", error);
    throw error;
  }
};

export const actionAccessRequest = async (payload) => {
  const { id, ...rest } = payload;
  const URL = `${URI}/accessRequest/${id}/action`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "put",
      data: rest,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during action access request:", error);
    throw error;
  }
};

export const getAllReviewList = async (payload) => {
  const URL = `general/review`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
      params: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during get all review list:", error);
    throw error;
  }
};

export const uploadFolder = async (payload, signal) => {
  const URL = `${URI}/upload`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "post",
      data: payload,
      signal,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during upload folder:", error);
    throw error;
  }
};

export const getStaticPages = async (payload) => {
  let { type, ...rest } = payload;
  const URL = `general/staticPage/${type}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
      params: rest,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during Get Static Page:", error);
    throw error;
  }
};
